import { NotificationBase } from 'notifications/typings/notifications'

export const handleSound = (notification: NotificationBase) => {
  if (notification.soundOn && notification.sound) {
    new Audio(`https://s3.amazonaws.com/tide-assets/drift-${notification.sound}.mp3`)
      .play()
      .catch(function(error) {
				// eslint-disable-next-line no-console
				console.error(error)
      })
  }
}
